import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch,useSelector } from "react-redux";

//import mainlogo from "../../Assets/Images/main-logo.png";
import greylogo from "../../Assets/Images/greylogo.png";
import fullwidthlogo from '../../Assets/Images/footer-logo.png'
import FeatherIcon from "feather-icons-react";
import ProfileDropdown from './ProfileDropdown';
import NotificationDropdown from './NotificationDropdown';

// images for notifications
//import profilePic from "../../Assets/Images/users/avatar-1.jpg";
import { LoginAction } from '../../Redux/Actions/AuthAction';
import { IReduxState } from '../../utils/types';  

interface TopbarProps {
    hideLogo?: boolean;
    navCssClasses?: string;
    openLeftMenuCallBack?: () => void;
    topbarDark?: boolean;
    setLeftSideBarType: React.Dispatch<React.SetStateAction<string>>;
    leftSideBarType?: string;
}
 
 
const Topbar = ({
    hideLogo,
    navCssClasses,
    openLeftMenuCallBack,
    topbarDark,
    leftSideBarType,
    setLeftSideBarType
  }: TopbarProps) =>{
 
    const dispatch = useDispatch();
    const reduxState = useSelector((state: IReduxState) => state.Auth);
    const navbarCssClasses: string = navCssClasses || "";
    const containerCssClasses: string = !hideLogo ? "container-fluid" : "";
    let fullLogo, shortLogo;
    
    if(reduxState.logo_folder && reduxState.controlium_type) {
      fullLogo = require(`../../Assets/Images/${reduxState.logo_folder}/fullLogo.png`);
      shortLogo = require(`../../Assets/Images/${reduxState.logo_folder}/shortLogo.png`)
    } else {
      fullLogo = fullwidthlogo;
      shortLogo = greylogo;
    }


    window.addEventListener("load", (event) => { 
      if(reduxState?.user){ 
        dispatch(LoginAction(reduxState?.user,true)) 
      }
    }); 

    return (
      <React.Fragment>
        <div className={`navbar-custom ${navbarCssClasses}`}>
          <div className={containerCssClasses}>
            {!hideLogo && (
              <div className="logo-box">
                <Link to="/admin" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={shortLogo} alt="" height="24"/>
                  </span>
                  <span className="logo-lg">
                    <img src={fullLogo} alt="" height="24" />
                  </span>
                </Link> 
              </div>
            )}
            <ul className="list-unstyled topnav-menu float-end mb-0">
              <li className="dropdown notification-list topbar-dropdown">
                <NotificationDropdown />
              </li>
              <li className="dropdown notification-list topbar-dropdown">
                  <ProfileDropdown />
              </li>
            </ul>
            <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
                <li>
                  <button
                    className="button-menu-mobile"
                    onClick={()=>setLeftSideBarType(leftSideBarType==='default'?'condensed':'default')}
                  >
                    <FeatherIcon icon="menu" />
                    <i className="fe-menu"></i>
                  </button>
                </li>  
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
}
export default Topbar;